import type { DocumentCenterType } from './api/documentCenterApi';

export type DocumentCenterTypeFilterValue = 'ALL' | DocumentCenterType;

export interface DocumentCenterVisibilityCapabilities {
  canViewSalesDocuments: boolean;
  canViewPurchaseDocuments: boolean;
  canViewWarehouseDocuments: boolean;
}

export interface DocumentCenterTypeFilter {
  value: DocumentCenterTypeFilterValue;
  labelKey: string;
}

const TYPE_FILTERS: DocumentCenterTypeFilter[] = [
  { value: 'ALL', labelKey: 'documentCenter:tabs.all' },
  { value: 'PZ', labelKey: 'documentCenter:types.PZ' },
  { value: 'WZ', labelKey: 'documentCenter:types.WZ' },
  { value: 'SALES_INVOICE', labelKey: 'documentCenter:types.SALES_INVOICE' },
  { value: 'PURCHASE_INVOICE', labelKey: 'documentCenter:types.PURCHASE_INVOICE' },
];

export function canSeeDocumentCenterFinancialDocuments(
  capabilities: Pick<DocumentCenterVisibilityCapabilities, 'canViewSalesDocuments' | 'canViewPurchaseDocuments'>
): boolean {
  return capabilities.canViewSalesDocuments || capabilities.canViewPurchaseDocuments;
}

export function canSeeDocumentCenterAmounts(capabilities: DocumentCenterVisibilityCapabilities): boolean {
  return canSeeDocumentCenterFinancialDocuments(capabilities) || capabilities.canViewWarehouseDocuments;
}

export function getDocumentCenterSubtitleKey(capabilities: DocumentCenterVisibilityCapabilities): string {
  return canSeeDocumentCenterFinancialDocuments(capabilities)
    ? 'documentCenter:subtitle'
    : 'documentCenter:subtitleOperational';
}

export function getVisibleDocumentCenterTypeFilters(
  capabilities: DocumentCenterVisibilityCapabilities
): DocumentCenterTypeFilter[] {
  const canSeeFinancialDocuments = canSeeDocumentCenterFinancialDocuments(capabilities);

  return TYPE_FILTERS
    .filter((item) => (
      (item.value !== 'SALES_INVOICE' || capabilities.canViewSalesDocuments)
        && (item.value !== 'PURCHASE_INVOICE' || capabilities.canViewPurchaseDocuments)
        && (item.value !== 'PZ' || capabilities.canViewWarehouseDocuments)
        && (item.value !== 'WZ' || capabilities.canViewWarehouseDocuments)
    ))
    .map((item) => (
      item.value === 'ALL' && !canSeeFinancialDocuments
        ? { ...item, labelKey: 'documentCenter:tabs.operationalAll' }
        : item
    ));
}
